import particlesPackage from 'particles.js/particles';
import { $qs, $qsa } from '../../utils/QuerySelector';

import gsap from 'gsap';

import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function bannerDeal() {

    if($qs('#particles-js')){
    particlesJS.load('particles-js', '/wp-content/themes/ciesco/src/particlesjs-config.json', function() { });

    if($qs('#particles-js').dataset.value == 'pinned'){
    let pinLogo = ScrollTrigger.create({
        trigger: "body",
        pin: '#particles-js',
        pinSpacing: false,
        start: "top top",
        end: "bottom bottom",
        markers: false,
       
      });
    }

    }

    const animatedCircle = $qs('[data-name="banner-animated-circle"]');

    if (!animatedCircle) return;

       

        $qs('body').addEventListener('mousemove', (e) => {

            let x = e.clientX;
            let y = e.clientY;
            let distance = 80;
            
            x = x - screen.width/2;
            y = y - screen.height/2;
            x = x / distance;
            y = y / distance;
           
            gsap.to( animatedCircle, { transformOrigin: 'center', x: x, y: y, duration: 0.5 } );
         

        });



}


export default bannerDeal;